<div
  (click)="onClick($event)"
  (mouseleave)="mouseLeave.emit()"
  (mouseover)="mouseOver.emit()"
  [ngbTooltip]="tooltip"
  class="control-button-group"
  placement="{{ placement }}">
  <a class="control-button" [class.disabled]="showLoader || disabled">
    <app-icon
      [hasCount]="hasCount"
      [count]="count"
      *ngIf="icon && !showLoader"
      [name]="icon"
      [disabled]="disabled"
      [colourClass]="colourClass"
      [ngStyle]="{ 'font-size.px': getFontSize() }"></app-icon>
    <div>
      <div
        class="spinner-border spinner-border-sm mb-1"
        role="status"
        *ngIf="showLoader"></div>
    </div>
    <span
      [class.disabled]="showLoader || disabled"
      [ngStyle]="{
        'font-size.px': buttonLabelSize,
        'margin-top.px': labelVerticalAdjustment,
      }"
      >{{ label }}</span
    >
  </a>
</div>
